import React, { useEffect, useMemo, useState } from 'react';
import Select from 'react-select';
import { customStyles, customTheme } from './UserDefaultGroupDropDownStyles';
import { updateUsersDefaultGroup } from '../../../api/user-setting';
import toast from 'react-hot-toast';
import { useCompanyDetailsContext } from 'context/companyData';
import { Tooltip } from '@mui/material';

export default function UserDefaultGroupDropDown({ defaultGroup, userId }) {
  const { groups, fetchGroups, loading } = useCompanyDetailsContext();

  const getGroupOptions = useMemo(() => {
    const groupOptions = groups.map((group) => ({
      value: group._id,
      label: group.name,
      type: 'Group'
    }));
    groupOptions.unshift({
      value: null,
      label: 'None',
      type: 'Group'
    });
    return groupOptions;
  }, [groups]);

  const [selectedGroup, setSelectedGroup] = useState(null);

  useEffect(() => {
    fetchGroups();
  }, []);

  useEffect(() => {
    if (defaultGroup?._id) {
      const found = getGroupOptions.find((option) => option.value === defaultGroup._id);
      setSelectedGroup(found || null);
    }
  }, [getGroupOptions, defaultGroup?._id]);

  const handleStatusChange = async (option) => {
    try {
      const updateStatusResponse = await updateUsersDefaultGroup(userId, option.value);
      toast.success(updateStatusResponse?.data?.message);
      setSelectedGroup(option);
    } catch (e) {
      toast.error(e?.response?.data?.error);
    }
  };

  return (
    <Tooltip title={selectedGroup?.label}>
      <div className="relative">
        <Select
          theme={customTheme}
          isLoading={loading?.groups}
          styles={customStyles}
          value={selectedGroup}
          options={getGroupOptions}
          menuPortalTarget={document.body}
          isSearchable={false}
          onChange={handleStatusChange}
          components={{
            IndicatorSeparator: () => null,
            IndicatorsContainer: () => null
          }}
        />
      </div>
    </Tooltip>
  );
}
